export class OrganizationCourseModel {
	public title: string;
	public course_number: string;
	public version: string;
	public description: string;
	public credits: number;
	public terms: string[];
	public subject_areas: string[];
}
